import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-category-illustrations-icon',
  templateUrl: 'category-illustrations.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryIllustrationsIcon {}
